import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 11.0006L1 19.5008C1 20.324 1.676 21 2.49924 21L21.5008 21C22.3262 21 23 20.324 23 19.5008L23 6.50066C23 5.67518 22.324 5.00142 21.5008 5.00142L6.99919 5.00142L1 5.00142L1 11.0006Z",
		fill: "#F5C235"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 3.99976C1 3.44747 1.44772 2.99976 2 2.99976H8C8.55228 2.99976 9 3.44747 9 3.99976V4.99976H1V3.99976Z",
		fill: "#B99531"
	})]
});
export default SvgFolder;
